import "./location.css";

import {ReactComponent as ShopIcon} from "../../../../assets/images/icons/shop.svg";
import {ReactComponent as ScheduleIcon} from "../../../../assets/images/icons/schedule.svg";
import {ReactComponent as CrossIcon} from "../../../../assets/images/icons/cross.svg";

import { Schedule } from "./shedule/schedule";
import { Contacts } from "./contacts/contacts";
import { Socials } from "./socials/socials";

export const LocationModal = ({props}) => {
    const {about, schedule} = props;

    return (
        <div className="modal fade" id="location-modal" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-4" id="exampleModalSmLabel">{about?.companyName}</h1>
                        <CrossIcon data-bs-dismiss="modal" className="btn-close"/>
                    </div>
                    <div className="modal-body">
                        {about.about && 
                            <div className=" border-bottom border-secondary-subtle">
                                <div className="d-flex align-items-center">
                                    <ShopIcon/>
                                    <p className="h3 m-0 ms-2">Про нас</p>
                                </div>
                                <p className="fs-5 ms-3">{about.about}</p>
                            </div>
                        }   
                        {schedule &&
                            <div className="border-bottom border-secondary-subtle mt-3">
                                <div className="d-flex align-items-center">
                                    <ScheduleIcon/>
                                    <p className="h3 m-0 ms-2">Графік роботи</p>
                                </div>
                                <Schedule schedule={schedule()}/>
                            </div>
                        }

                        <Contacts props={about}/>

                        {/* <Socials props={{instagram: props?.instagram, facebook: props?.facebook, tiktok: props?.tiktok}}/> */}
                        
                        <div className="mt-2 text-center">
                           <a className="text-decoration-none" href="#">Політика конфіденційності</a>
                        </div>
                    </div>
                    {/* <div className="modal-footer call-wrap">
                        <a className="call-button fs-5 fw-bold" href={`tel:${props?.[2]?.value}`}>
                            Зателефонувати
                        </a>
                    </div> */}
                </div>
            </div>
        </div>
    )
}